import controller from './dashboard.controller';
import template from './dashboard.view.html';

let DashboardComponent = {
  template,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

export default DashboardComponent;



/** WEBPACK FOOTER **
 ** C:/Users/dares/Documents/SIESA_repositorios/himalaya/www/components/pay-zone/dashboard/dashboard.component.js
 **/